// extracted by mini-css-extract-plugin
module.exports = {"timeButton":"time_button_timeButton__I09iV","focusedTime":"time_button_focusedTime__2jOPo","test":"time_button_test__1HOP_"};